const SERVER = "https://live.livelifeindo.com"
// const SERVER = "https://api.livelifeindo.com"

module.exports = {
    SERVER
}
